module.exports = __webpack_public_path__ + "static/img/product08-1.1c2ceb2f.png";